import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { base_url } from "../utils/baseUrl";
import { useFormik } from "formik";
import axios from "axios";
import Loader from "../utils/loder";

let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  cname: yup.string().required("compny name is Required"),
  email: yup.string().required("email is Required"),
  phone: yup.string().required("phone is Required"),
  address: yup.string().required("address is Required"),
  specialization: yup.string().required("specialization is Required"),
  image: yup.mixed().required(" Image is Required"),
  image1: yup.mixed().required("document is Required")
});
const AddNewscat = () => {
  const navigate = useNavigate();
  const [imageErrorone, setImageErrorone] = useState("");
  const [imageErrortwo, setImageErrortwo] = useState("");
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      cname: "",
      email: "",
      phone: "",
      country: "",
      address:"",
      specialization: "",
      image: null,
      image1: null,

    },
    validationSchema: schema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("name", values.name);
        formData.append("cname", values.cname);
        formData.append("email", values.email);
        formData.append("phone", values.phone);
        formData.append("country", values.country);
        formData.append("address", values.address);
        formData.append("specialization", values.specialization);
        formData.append("image", values.image);
        formData.append("document", values.image1);
        console.log(formData);
        // Make API call using axios
        const response = await axios.post(`${base_url}addDmc`, formData);
        setLoading(false);
        alert("Form submitted successfully!");
        // Handle response
        window.location.reload();

        // Optionally, navigate to another page upon successful submission
        // Navigate to a success page
      } catch (error) {
        setLoading(false);
        alert("Something Went Wrong");
        console.log("API Error:", error);
      }
    },
  });
  return (

    <div className="container">
      {loading ? (
            <Loader color="#00BFFF" height={50} width={50} />
          ) : (
      <div className="box-container" style={{ border: "5px solid blue", boxShadow: "0 0 50px red" }}>
        <h3 className="mb-4  title" style={{ marginTop: "300px" }}>
          Indian International Travel Professional
        </h3>
        <div>
          
            <form action="" onSubmit={formik.handleSubmit}>
              <CustomInput
                type="text"
                name="name"
                onChng={formik.handleChange("name")}
                onBlr={formik.handleBlur("name")}
                val={formik.values.name}
                label="Enter Name"
              />
              <div className="error">
                {formik.touched.name && formik.errors.name}
              </div>


              <CustomInput
                type="text"
                label="Enter Compny Name"
                name="cname"
                onChng={formik.handleChange("cname")}
                onBlr={formik.handleBlur("cname")}
                val={formik.values.cname}
              />
              <div className="error">{formik.touched.cname && formik.errors.cname}</div>


              <CustomInput
                type="text"
                label="Enter email"
                name="city"
                onChng={formik.handleChange("email")}
                onBlr={formik.handleBlur("email")}
                val={formik.values.email}
              />
              <div className="error">{formik.touched.email && formik.errors.email}</div>


              <CustomInput
                type="text"
                label="Enter phone"
                name="phone"
                onChng={formik.handleChange("phone")}
                onBlr={formik.handleBlur("phone")}
                val={formik.values.phone}
              />
              <div className="error">{formik.touched.phone && formik.errors.phone}</div>

              <CustomInput
                type="text"
                label="Enter Address"
                name="address"
                onChng={formik.handleChange("address")}
                onBlr={formik.handleBlur("address")}
                val={formik.values.address}
              />
              <div className="error">{formik.touched.address && formik.errors.address}</div>

              <CustomInput
                type="text"
                label="Enter specialization"
                name="specialization"
                onChng={formik.handleChange("specialization")}
                onBlr={formik.handleBlur("specialization")}
                val={formik.values.specialization}
              />
              <div className="error">{formik.touched.specialization && formik.errors.specialization}</div>

              <div className="mt-4">
                <label htmlFor="image" className="form-label">Select Photo</label>
                <input
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  onChange={(e) => {
                    formik.setFieldValue("image", e.currentTarget.files[0]);
                    setImageErrorone(""); // Clear image error when a new file is selected
                  }}
                  className="form-control"
                />
                <div className="error">{formik.touched.image && formik.errors.image}</div>
              </div>

              <div className="mt-4">
                <label htmlFor="image1" className="form-label">Select Document</label>
                <input
                  type="file"
                  id="image1"
                  name="image1"
                  accept="image/*"
                  onChange={(e) => {
                    formik.setFieldValue("image1", e.currentTarget.files[0]);
                    setImageErrortwo(""); // Clear image error when a new file is selected
                  }}
                  className="form-control"
                />
                <div className="error">{formik.touched.image1 && formik.errors.image1}</div>
              </div>
              <div className="text-center mt-3">

                <button
                  className="btn btn-success border-0 rounded-3 my-5"
                  type="submit"
                >
                  Submit
                </button>

              </div>
            </form>
          
        </div>
      </div>
      )}
    </div>

  );
};

export default AddNewscat;
